module.exports = __webpack_public_path__ + "static/media/ostrich.17ea7f51.svg";